import { render, staticRenderFns } from "./taiyuan.vue?vue&type=template&id=6b000d70&scoped=true"
import script from "./taiyuan.vue?vue&type=script&lang=js"
export * from "./taiyuan.vue?vue&type=script&lang=js"
import style0 from "./taiyuan.vue?vue&type=style&index=0&id=6b000d70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b000d70",
  null
  
)

export default component.exports